"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEachAsync = void 0;
const augmentative_iterable_1 = require("augmentative-iterable");
const recipes_1 = require("../recipes");
exports.forEachAsync = (0, recipes_1.forEachRecipe)(augmentative_iterable_1.augmentativeForEachAsync);
